import axios from 'axios';

/**
 * Download an inventory report as a browser file download.
 *
 * The organization is added by the axios request interceptor, so it must not be
 * passed here. The filename comes from the response, which is how a dated report
 * arrives as varastoarvo_2026-08-31.pdf rather than value.pdf.
 */
export async function downloadInventoryReport(reportType, format = 'pdf', params = {}) {
  const response = await axios.get(`/api/inventory/report/${reportType}/`, {
    params: { export_format: format, ...params },
    responseType: 'blob',
  });

  const blob = new Blob([response.data]);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;

  const contentDisposition = response.headers['content-disposition'];
  let filename = `${reportType}.${format === 'xlsx' ? 'xlsx' : 'pdf'}`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="(.+)"/);
    if (match) filename = match[1];
  }

  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

/** "yyyy-MM-dd" for the API, in local time. */
export function toDateString(date) {
  if (!date || Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Last day of the previous month: the date an accountant asks for. */
export function endOfPreviousMonth(today = new Date()) {
  return new Date(today.getFullYear(), today.getMonth(), 0);
}

/** Last day of the previous calendar year. */
export function endOfPreviousYear(today = new Date()) {
  return new Date(today.getFullYear() - 1, 11, 31);
}
